import CheckIcon from '@mui/icons-material/Check';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import { Box, Typography } from '@mui/material';
import { Trans } from 'react-i18next';

const multipleStyles = {
  bgcolor: '#f5f6ff',
  border: '1px solid #e0e7ff',
  borderLeft: '4px solid #6366f1',
  textColor: '#2d3161',
  iconColor: '#2d3161',
} as const;

const singleStyles = {
  bgcolor: '#f8fafc',
  border: '1px solid #e2e8f0',
  borderLeft: '4px solid #94a3b8',
  textColor: '#475569',
  iconColor: '#64748b',
} as const;

const MultipleChoiceIcon = ({ color }: { color: string }) => (
  <Box
    sx={{
      width: 14,
      height: 14,
      borderRadius: '3px',
      border: `1.5px solid ${color}`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    }}
  >
    <CheckIcon sx={{ fontSize: 10, color, fontWeight: 700 }} />
  </Box>
);

export const PalMcqSelectionBanner = ({
  isMultiple,
}: {
  isMultiple: boolean;
}) => {
  const theme = isMultiple ? multipleStyles : singleStyles;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        pl: 1.75,
        pr: 2,
        py: 1.5,
        borderRadius: '8px',
        mb: 1.5,
        mt: 2,
        bgcolor: theme.bgcolor,
        border: theme.border,
        borderLeft: theme.borderLeft,
      }}
    >
      {isMultiple ? (
        <MultipleChoiceIcon color={theme.iconColor} />
      ) : (
        <RadioButtonCheckedIcon
          sx={{ fontSize: 16, color: theme.iconColor, flexShrink: 0 }}
        />
      )}
      <Typography
        sx={{
          fontSize: 14,
          fontWeight: 500,
          color: theme.textColor,
          lineHeight: 1.5,
        }}
      >
        {isMultiple ? (
          <Trans
            i18nKey="PAL_Q_MCQ_INSTR_MULTIPLE"
            components={{
              emphasis: <Box component="span" sx={{ fontWeight: 700 }} />,
            }}
          />
        ) : (
          <Trans
            i18nKey="PAL_Q_MCQ_INSTR_SINGLE"
            components={{
              emphasis: <Box component="span" sx={{ fontWeight: 700 }} />,
            }}
          />
        )}
      </Typography>
    </Box>
  );
};
